/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {CommonModule} from '@angular/common';
import {TableModule} from '../../../shared/table/table.module';
import {AlertsMainPageComponent} from './alerts-main-page.component';
import {NgModule} from '@angular/core';
import {PaginationModule} from '../../../shared/pagination/pagination.module';
import {LoadingSpinnerModule} from '../../../shared/loading/loading-spinner/loading-spinner.module';
import {InputFilterModule} from '../../../shared/filter/input-filter/input-filter.module';
import {InputAndCodeFilterModule} from '../../../shared/filter/input-and-code-filter/input-and-code-filter.module';
import {DateFilterModule} from '../../../shared/filter/date-filter/date-filter.module';
import {CodeFilterModule} from '../../../shared/filter/code-filter/code-filter.module';
import {AlertsFormModule} from '../alerts-form/alerts-form.module';

@NgModule({
    declarations: [AlertsMainPageComponent],
    imports: [
        CommonModule,
        TableModule,
        PaginationModule,
        LoadingSpinnerModule,
        InputFilterModule,
        InputAndCodeFilterModule,
        DateFilterModule,
        CodeFilterModule,
        AlertsFormModule
    ]
})
export class AlertsMainPageModule {
}
